export const faqItems = [
  {
    question: '蜜芽的客服电话是多少？服务时间是什么时候？',
    answer: '蜜芽全国统一客服热线为400-xxx-xxxx，服务时间为周一至周日9:00-21:00。建议在拨打电话前准备好您的订单号，以便客服人员快速为您查询。您也可以通过蜜芽APP内的在线客服（9:00-22:00）、官方微信公众号或发送邮件至service@miya.com获取帮助。',
  },
  {
    question: '如何在蜜芽查询我的订单物流信息？',
    answer: '您可以通过以下方式查询订单物流：打开蜜芽APP，进入"我的"→"我的订单"，找到对应订单后点击"查看物流"即可查看详细物流轨迹。您也可以复制快递单号前往对应快递公司官网查询。订单付款后通常需要1-2个工作日备货发货，请耐心等待。',
  },
  {
    question: '蜜芽支持哪些支付方式？',
    answer: '蜜芽支持微信支付、支付宝、储蓄卡、信用卡以及蜜芽余额等多种支付方式。微信支付和支付宝最为便捷，部分信用卡消费还可享受银行积分和返现优惠。蜜芽余额充值常有额外赠送，适合经常购物的用户。',
  },
  {
    question: '蜜芽的退换货政策是怎样的？',
    answer: '蜜芽支持7天无理由退货（需保持商品原状），质量问题支持15天内换货或退货。退货流程：APP内"我的订单"→"申请售后"→填写原因并上传凭证→客服审核→寄回商品→仓库签收后3-5个工作日退款到账。无理由退货退回运费由买家承担，质量问题退货/换货运费由蜜芽承担。',
  },
  {
    question: '如何加入蜜芽官方社群获取最新资讯？',
    answer: '您可以通过以下方式加入蜜芽社群：添加蜜芽小助手微信号"miya_official"加入官方微信群；加入蜜芽官方QQ群（群号请在APP社群页面获取）；关注小红书"蜜芽Miya"、抖音"蜜芽"、微博"蜜芽官方微博"等社交媒体账号。社群成员可享受新人优惠券、专属秒杀和抽奖福利。',
  },
  {
    question: '蜜芽账户被盗了怎么办？',
    answer: '如果发现账户异常，请立即采取以下措施：1. 修改登录密码和支付密码；2. 联系蜜芽在线客服或拨打400-xxx-xxxx冻结账户；3. 检查关联的支付账户安全。蜜芽客服不会主动索要您的支付密码或验证码，请警惕假冒客服的诈骗行为。',
  },
  {
    question: '蜜芽会员等级有哪些？如何升级？',
    answer: '蜜芽会员分为普通会员、银卡会员（年消费满500元）、金卡会员（年消费满2000元）和钻石会员（年消费满5000元）四个等级。各等级享受不同的折扣优惠、优惠券福利和专属权益。满足消费条件后系统自动升级，无需手动操作。可在APP"我的"→"会员中心"查看当前等级和升级进度。',
  },
  {
    question: '蜜芽礼品卡怎么购买和使用？',
    answer: '在蜜芽APP"我的"→"礼品卡"中可购买50-1000元不等的礼品卡，支持个性化封面和祝福语定制。收到礼品卡后，在结算页面选择"蜜芽礼品卡"支付并输入卡号密码即可使用。礼品卡有效期12个月，可与其他优惠券叠加使用。',
  },
];